import { FORM_STATES } from '@bingads-webui-fluent-component/form';
import { PMAX_LITE_WIZARD_STEP_PATHS } from '@bingads-webui-campaign-react/pmax-lite-wizard-utils';

const DelayedCampaignDraftView =
  () => import(/* webpackChunkName: "campaign-draft-step.async" */ './campaign-draft-step')
    .then(({ CampaignDraftViewWithI18n }) => CampaignDraftViewWithI18n);

const DelayedCampaignDraftLazyRepository =
  () => import(/* webpackChunkName: "campaign-draft-step.async" */ './campaign-draft-lazy-repository')
    .then(({ CampaignDraftLazyRepositoryWithI18n }) => CampaignDraftLazyRepositoryWithI18n);

export const CampaignDraftStepConfig = {
  id: PMAX_LITE_WIZARD_STEP_PATHS.CAMPAIGN_DRAFT,
  view: DelayedCampaignDraftView,
  repository: DelayedCampaignDraftLazyRepository,
  machineOptions: {
    initialState: FORM_STATES.FETCHING,
  },
};
